import { useTranslation } from '@axo/shared/i18n';
import { Icon } from '@axo/ui-core/components/Icon';
import { InfoCard } from '@axo/ui-feature/components/InfoCard/InfoCard';
import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import { useAxoFormContext } from '../../../../../context/AxoForm/AxoForm';
import { calculateMonthlyPaymentNO } from '../../../../../utils/Norway/calculateMonthlyPaymentNO';
import { FinlandFormData } from '../../../FormData.fi.types';

export const SavingAmount = () => {
  const { t } = useTranslation();

  const { axoFormData } = useAxoFormContext<FinlandFormData>();

  const creditCardAppliedAmount = Number(
    useWatch({
      name: 'Debt/CreditCard/OutstandingAmount',
      defaultValue: 0,
    })
  );
  const personalAppliedAmount = Number(
    useWatch({
      name: 'Debt/Personal/OutstandingAmount',
      defaultValue: 0,
    })
  );
  const duration = axoFormData['LoanApplication/LoanDuration'] ?? 0;
  const amount = Number(creditCardAppliedAmount + personalAppliedAmount);

  const monthlySavings = useMemo(() => {
    // We are using the same calculation as NO here in FI (?)
    const currentCost = calculateMonthlyPaymentNO({
      amount,
      duration: 10,
      interestRate: 19.5,
    });
    const newCost = calculateMonthlyPaymentNO({
      amount,
      duration,
      interestRate: 10,
    });

    return currentCost - newCost;
  }, [amount, duration]);

  if (!creditCardAppliedAmount && !personalAppliedAmount) return null;

  if (!monthlySavings || monthlySavings <= 0) return null;

  return (
    <InfoCard
      title={t('SavingAmount.title', { amount: monthlySavings })}
      description={t('SavingAmount.description')}
      icon={<Icon name="info-solid" />}
    />
  );
};
